import type { KizenStepType } from 'pages/AutomationEngine/types';

import {
  AddErrorMessage,
  MessageDictionary,
} from 'pages/AutomationEngine/messageDictionary';
import {
  mapApiSource,
  mapFlowSource,
} from 'pages/AutomationEngine/dialogs/VariableWizard/variable-types/variableDTO';
import type { VariableUpdateStep } from '../actionSectionTypes';
import type {
  ApiVariableSource,
  ArrayAggregationMode,
  VariableNameAndType,
} from 'pages/AutomationEngine/dialogs/VariableWizard/types';

type APIObject = {
  variable: Omit<VariableNameAndType, 'id' | 'dataSubtype'> & {
    id: string;
    dataSubtype?: VariableNameAndType['dataSubtype'] & {
      id: string;
      description: string;
    };
  };
  isRequired: boolean;
  arrayAggregationMode: ArrayAggregationMode;
  deduplicateArray: boolean;
  sources: ApiVariableSource[];
};

const forFlow = (
  apiObject: APIObject,
  addErrorMessage: AddErrorMessage,
  messageDictionary: MessageDictionary,
  stepType: KizenStepType
) => {
  const {
    variable,
    isRequired,
    arrayAggregationMode,
    deduplicateArray = false,
    sources,
  } = apiObject;

  return {
    isRequired,
    type: stepType,
    chosenVariable: {
      label: variable?.name,
      value: variable?.name.replaceAll(' ', '_'),
      meta: variable,
    },
    variable: {
      ...variable,
      dataSubtype: variable?.dataSubtype && {
        ...variable.dataSubtype,
        label: variable.dataSubtype.description,
        value: variable.dataSubtype.id,
      },
    },
    arrayAggregationMode,
    deduplicateArray,
    sources: sources.map(
      mapFlowSource(variable?.id, messageDictionary, addErrorMessage)
    ),
  };
};

const forApi = (step: VariableUpdateStep) => {
  const { variable, isRequired, arrayAggregationMode, deduplicateArray } =
    step.details;

  const sources = (step.details.sources || []).map((s) =>
    mapApiSource(s, variable?.isArray)
  );

  const api = {
    ...step,
    details: {
      isRequired,
      variable: variable?.name,
      sources,
      arrayAggregationMode: arrayAggregationMode || 'add_all',
      deduplicateArray: deduplicateArray || false,
    },
  };

  return api;
};

export const updateVariableDTO = { forApi, forFlow };
